export const getPathName = (): string => window.location.pathname;

export const getSearch = (): string => window.location.search;
